import React from 'react';
import { Button, Steps } from 'antd';
import { withTranslation } from "react-i18next"
import registerLogo from '../../assets/img/registerLogo.png'
import ResetPasswordForm from './resetPasswordForm';
import successImg from '../../assets/img/illustrate_success.png'



class PasswordFind extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            current: 0,
            captchaImg: ''
        }
    }


    onNext = () =>{
        const current = this.state.current
        this.setState({ current: current + 1 })
    }

    onPrev = () =>{
        const current = this.state.current;
        this.setState({ current: current - 1 });
    }

    toHome = () =>{
        console.log('this==',this.props)
        this.props.history.push('/home');
    }
    
    steps = [
        {
            title: this.props.t('resetPassword', { defaultValue: '重置密码' }),
            // '重置密码',
            content: <ResetPasswordForm history={this.props.history} onNext={this.onNext} onPrev={this.onPrev} />,
        },
        {
            title: this.props.t('complete', { defaultValue: '完成' }),
            content: (
                <div className="password-form">
                    <div style={{ textAlign:'center' }}><img src={successImg} alt="" /></div>
                    <p style={{ textAlign:'center' }}>{this.props.t('editPasswordMsg', { defaultValue: '您的密码修改成功！' })}</p>
                    <Button onClick={this.toHome} type="primary" className="password-login-form-button">{this.props.t('loginNow', { defaultValue: '立即登录' })}</Button>
                </div>
            ),
        },
    ];

    items = this.steps.map((item) => ({ key: item.title, title: item.title }));

    
    render() {
        const { data } = this.props;
        console.log('data:',data);
        return (
        <div className="password-container password-layout">
            <div className="password-layout-content">
                <div className="password-tab">
                <div className="register-logo">
                    <img src={registerLogo} alt='' />
                </div>
                <div className="password-steps">
                    <Steps current={this.state.current} items={this.items} />
                    <div className='steps-div' >{this.steps[this.state.current].content}</div>
                </div>

                <div className='login-text' onClick={this.toHome}>{this.props.t('directLogin', { defaultValue: '直接登录' })}</div>
                </div>
            </div>
            <div className="password-layout-footer">
                { this.props.t('copyRight', { defaultValue: '@三一集团有限公司 版权所有 | 湘ICP备10005672号-14' }) }
            </div>
        </div>
        )
    }
}

// export default PasswordFind
export default PasswordFind = withTranslation()(PasswordFind);